import React from 'react';
import PropTypes from 'prop-types';
import { imageContent } from '../FormContext/UploadsContext';



const ThumbnailsGrid = ({ file }) => {
 if (!file) return null;

  return (
  
      <div key={file.id || Math.random()}>
        {imageContent(file)}
      </div>
   
  );
};



ThumbnailsGrid.propTypes = {

  file: PropTypes.object
};

export default ThumbnailsGrid;
